// Globals
let hideMenuTimer;

// Glboal menu state, might be used for later for more menu animation
let $state = {
    firstLink: true,
    hadPrevLink: false,
    prevLinkHtml: {
        index: 0,
        listItem: '',
        anchor: '',
        direction: 0
    }
};

/**
 * MAIN FUNC
 * 
 * @return void
 */
export const MainMenuJS = () => {
    let htmlMenu = document.querySelectorAll('#main-menu .menu-item');
    //  [Responsive] For larger than tablet size 
    // change from 1028 to 1200
    if (window.innerWidth > 1200) {
        desktopMenuBehaviour( htmlMenu );
    }

    // [Responsive] For tablets and phones
    // change from 1027 to 1200
    if (window.innerWidth < 1200) {
        mobileMenuBehaviour( htmlMenu );
    }

    // Resize event to make sure things are working properly even when resizing the window
    window.addEventListener('resize', function () {
        //  [Responsive] For larger than tablet size
        if (window.innerWidth > 1200) {
            desktopMenuBehaviour( htmlMenu );
        }
    
        // [Responsive] For tablets and phones
        if (window.innerWidth < 1200) {
            mobileMenuBehaviour( htmlMenu );
        }
    })

}  // end defaults

/**
 * Desktop behaviour for the Main Menu
 * 
 * @param {HTMLAllCollection} _htmlMenu 
 */
const desktopMenuBehaviour = (_htmlMenu) => {
    _htmlMenu.forEach(function (listItem) {

        //remove on click dropdown
        listItem.removeEventListener('click', () => { })

        // Add mouse hover event
        listItem.addEventListener('mouseover', function (e) {

            let anchor = this.querySelector('.nav-link');
            let itemIndex = getNavMenuLinkIndex(listItem);
            let direction = getDirectionalPos(listItem);

            if (anchor) {

                //check if the user already had a prev link hovered
                if ($state.hadPrevLink && $state.prevLinkHtml.listItem != "") {

                    let li = $state.prevLinkHtml.listItem;
                    let an = $state.prevLinkHtml.anchor;

                    hideMenu(li, an);

                    // Clear out the delay immediately
                    clearTimer();
                }

                //clear the delay on prev link
                showMenu(listItem, anchor);

                // Save current main menu behaviour state
                saveState( anchor, itemIndex, listItem, direction );
            }
        });

        // Add mouse leave event
        listItem.addEventListener('mouseleave', function (e) {
            //add Class to list item
            listItem.classList.remove('show');
            let anchor = this.querySelector('.nav-link');
            let itemIndex = getNavMenuLinkIndex(listItem);
            let direction = getDirectionalPos(listItem);

            if (anchor) {
                onHideDelay(listItem, anchor);

                // Save current main menu behaviour state
                saveState( anchor, itemIndex, listItem, direction );
            }
        })
    });
}

/**
 * Main menu behaviour when in mobile view
 * 
 * @param {HTMLAllCollection} _htmlMenu 
 */
const mobileMenuBehaviour = (_htmlMenu) => {
    const mobileMenu = document.querySelector('.mobile-footer-menu-container');
    const mobileFooterButtons = document.querySelector('.mobile-footer-buttons');
    const btnExplore = document.querySelector('.nav-footer-menu');
    const toggler = document.querySelector('.navbar-toggler');
    const dropDownNav = document.getElementById('navbarNavOffcanvas');

    // Adjust the position of the mobile footer buttons if the mobile menu is empty
    if (mobileMenu && mobileFooterButtons) {
        if (mobileMenu.children.length > 0) {
            mobileFooterButtons.classList.add('mv');
        } else {
            mobileFooterButtons.classList.remove('mv');
        }
    }

    // Scroll function for mobile menu
    if (mobileMenu) {
        mobileFooterScroll();
    }

    // Add btn explore event listener
    if (btnExplore && toggler) {
        btnExploreAction(btnExplore, toggler, dropDownNav);
    }

    //Close the navDropDown when the user clicks outside of it
    if (dropDownNav) {
        dropdownNavEvents(btnExplore, dropDownNav);
    }

};


/**
 * Add explore button event listener
 * 
 * @param {HTMLCollection} _btnExplore 
 * @param {HTMLCollection} _btnToggle 
 * @param {HTMLCollection} _dropdownNav 
 * 
 * @return void;
 */
const btnExploreAction = (_btnExplore, _btnToggle, _dropdownNav) => {

    _btnExplore.addEventListener('click', e => {
        e.preventDefault();
        // When the button was clicked, do nav dropdown function
        if (_btnExplore.classList.contains('active') && _dropdownNav.classList.contains('show')) {
            openNavDropDown(false);
        } else {
            openNavDropDown(true);
        }

        // Code to catch icon user click event
        // if( e.target.tagName == "I" || e.target.tagName == "i" ) {
        //     let parentTarget = e.target.parentElement.parentElement;

        //     console.log(parentTarget);
        //     if ( parentTarget.classList.contains('active') && _dropdownNav.classList.contains('show') ) {
        //         openNavDropDown(false);
        //     } else {
        //         console.log('23')
        //         openNavDropDown(true);
        //     }
        // }
    });

}

/**
 * Programatically open and close the nav dropdown
 * 
 * @param {boolean} _open 
 * 
 * @return void;
 */
const openNavDropDown = (_open = true) => {
    const toggler = document.querySelector('.navbar-toggler');
    const btnExplore = document.querySelector('.nav-footer-menu');
    const dropDownNav = document.getElementById('navbarNavOffcanvas');

    //Do close
    if (_open) {
        toggler.classList.remove('collapsed');
        dropDownNav.classList.add('open');
        dropDownNav.classList.add('show');
        btnExplore.classList.add('active');
        document.body.style.overflow = 'hidden';

    } else {
        toggler.classList.add('collapsed');
        dropDownNav.classList.remove('open');
        dropDownNav.classList.remove('show');
        btnExplore.classList.remove('active');
        document.body.style.overflow = 'visible';
    }
}

/**
 * Dropdow events for the nav dropdown
 * 
 * @param {HTMLCollection} _btnExplore
 * @param {HTMLCollection} _dropdownNav
 */
const dropdownNavEvents = (_btnExplore, _dropdownNav) => {

    document.addEventListener('click', e => {
        let _tester = false;
        const navlink = _btnExplore.querySelector('.nav-link');
        const mainMenuNavlinks = document.querySelectorAll('#main-menu .nav-link');

        // Main menu nav links
        mainMenuNavlinks.forEach(link => {
            if (e.target == link) _tester = true;
        })

        //if clicking the explore button, return immediately
        if (e.target == _btnExplore || e.target == navlink || _tester) return;

        // close the nav dropdown if the user clicks outside of it
        if (_dropdownNav.classList.contains('show') && e.target !== _dropdownNav) {
            openNavDropDown(false);
        }
    });
}

/**
 * Delays the menu's hide animation for a few seconds
 * 
 * @param {HTMLAllCollection} listItem 
 * @param HTMLAllCollection} anchor 
 * @param {*} clear 
 */
const onHideDelay = (listItem, anchor, clear = false) => {
    hideMenuTimer = window.setTimeout(() => {
        hideMenu(listItem, anchor);
    }, 500)
}

/**
 * Scroll function for the mobile footer menu
 */
const mobileFooterScroll = () => {

    // Save previous position of the window
    let lastScrollPos = window.pageYOffset;

    let windowWidth = window.innerWidth;
    let _onMobile = windowWidth <= 800;
    const $mobileMenu = document.querySelector('.mobile-footer-menu-container');
    const $mainnav = document.getElementById('wrapper-navbar');
    const $mobileFooterButtons = document.querySelector('.mobile-footer-buttons');
    const offset = $mainnav.offsetHeight + 50;

    const $navbar = $mainnav.querySelector('nav');

    // Check defaults if header needs to be updated on refresh
    if (document.body.scrollTop > 75 || document.documentElement.scrollTop > 75) {
        if (document.body.scrollTop > 75 || document.documentElement.scrollTop > 75) {
            if (!_onMobile) {
                if (!$navbar.classList.contains('scroll-fixed')) {
                    // $navbar.classList
                    $navbar.classList.add('scroll-fixed');
                }
            }
        } else {
            if (!_onMobile) {
                if ($navbar.classList.contains('scroll-fixed')) {
                    // $navbar.classList
                    $navbar.classList.remove('scroll-fixed');
                }
            }
        }
    }

    //Detect scroll direction
    window.onscroll = function () {

        // Get current position of the window
        let currentScrollPos = window.pageYOffset;

        // Add scroll class when user scroll down the page.
        if (document.body.scrollTop > 75 || document.documentElement.scrollTop > 75) {
            if (!_onMobile) {
                if (!$navbar.classList.contains('scroll-fixed')) {
                    // $navbar.classList
                    $navbar.classList.add('scroll-fixed');
                }
            }
        } else {
            if (!_onMobile) {
                if ($navbar.classList.contains('scroll-fixed')) {
                    // $navbar.classList
                    $navbar.classList.remove('scroll-fixed');
                }
            }
        }

        // UPWARD SCROLLING
        // --------------------------------------
        if (lastScrollPos > currentScrollPos) {

            if (_onMobile) {
                //Show the mobile menu
                if ($mobileMenu.classList.contains('hide')) {
                    $mobileMenu.classList.remove('hide');
                }


                //Show The Main Nav
                if ($mainnav.classList.contains('main-hide')) {
                    $mainnav.classList.remove('main-hide');
                }

                if ($mobileFooterButtons && !$mobileFooterButtons.classList.contains('mv')) {
                    $mobileFooterButtons.classList.add('mv');
                }
            }

            // DOWNWARD SCROLLING
            // --------------------------------------
        } else if (currentScrollPos > offset) {

            if (_onMobile) {
                // Hide the mobile menu
                if (!$mobileMenu.classList.contains('hide')) {
                    $mobileMenu.classList.add('hide');
                }

                // Hide the main nav
                if (!$mainnav.classList.contains('main-hide')) {
                    $mainnav.classList.add('main-hide');
                }

                if ($mobileFooterButtons && $mobileFooterButtons.classList.contains('mv')) {
                    $mobileFooterButtons.classList.remove('mv');
                }
            }

        } // else was horizontal scroll

        lastScrollPos = currentScrollPos; // For Mobile or negative scrolling 
    }
}

/**
 * Clear out the time of the main menu
 */
const clearTimer = () => {
    window.clearTimeout(hideMenuTimer);
}

/**
 * Menu behaviour for showing and hiding
 *
 * @param {*} listItem 
 * @param {*} anchor 
 * @param {*} _hide 
 */
const menuBehavior = (listItem, anchor, _hide = false) => {
    let sibling = anchor.nextElementSibling;

    //check current behaviour
    //check if sibling is available
    if (sibling) {
        if (!_hide) {
            listItem.classList.add('show');
            anchor.ariaExpanded = true;
            sibling.classList.add('show');
        } else {
            listItem.classList.remove('show');
            anchor.ariaExpanded = false;
            sibling.classList.remove('show');
        }
    }
}

// wrapper functions
export const showMenu = (listItem, anchor) => menuBehavior(listItem, anchor);
export const hideMenu = (listItem, anchor) => menuBehavior(listItem, anchor, true);

/**
 * Get the index of the element
 * 
 * @param {*} el 
 */
const getNavMenuLinkIndex = (el) => {
    const navMenu = document.getElementById('main-menu');

    return Array.prototype.slice.call(el.parentElement.children).indexOf(el)
}

/**
 * Get the direction of the mouse towards the link
 * s
 * @param {*} el 
 */
const getDirectionalPos = (el) => {
    let prevLinkIndex = $state.prevLinkHtml.index;
    let nextLinkIndex = getNavMenuLinkIndex(el);


    if (prevLinkIndex < nextLinkIndex) {
        return "toRight";
    }

    return "toLeft";
}

/**
 * Save the state of the menu
 * 
 * @param {*} anchor 
 * @param {*} itemIndex 
 * @param {*} listItem 
 * @param {*} direction 
 */
const saveState = ( anchor, itemIndex, listItem, direction ) => {
    $state.hadPrevLink = true;
    $state.prevLinkHtml.anchor = anchor;
    $state.prevLinkHtml.index = itemIndex;
    $state.prevLinkHtml.listItem = listItem;
    $state.prevLinkHtml.direction = direction;
}